require('../../modules/es.array.reverse');
var entryUnbind = require('../../internals/entry-unbind');

module.exports = entryUnbind('Array', 'reverse');
